<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <PlacePartForm
      v-if="!isLoading"
      :placePartData="placePartData"
      :submitName="$t('add')"
      v-on:addOrUpdatePlacePart="addOrUpdatePlacePart"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import PlacePartForm from "@/components/places/placesParts/PlacePartForm.vue";
import PlacePart from "@/models/places/placesParts/PlacePart";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "PlacePartAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    PlacePartForm,
  },
  props: {
    placeToken: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      placePartData: new PlacePart(),
    };
  },
  methods: {
    async addOrUpdatePlacePart() {
      this.isLoading = true;
      try {
        let response = await this.placePartData.addOrUpdatePlacePart(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.placePartData.setInitialValue();
          this.placePartData.placeToken = this.placeToken;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.placePartData.placeToken = this.placeToken;
  },
};
</script>

